import React, { useEffect, useState, useMemo, useRef } from "react";
import { State, City } from "country-state-city";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { BsCloudUpload } from "react-icons/bs";
import { FaArrowLeft } from "react-icons/fa";
import Select from "react-select";

import { AddContractorApi, UpdateContractorApi } from "../../Api/Operations/Contractors";
import { getallContractors } from "../../Redux/actions/Operationsactions/getcontractors";
import { AddVendorApi, UpdateVendorApi } from "../../Api/Operations/Vendors";
import { getallVendors } from "../../Redux/actions/Operationsactions/getvendors";
import ActionButton from "../Common/ActionButton";
import noImage from "../../assets/noImage.png";
import { InputField, SelectField, TextAreaField } from "../Common/FormComponents";
import "./AddContractorsAndVendors.css";

const CONTRACTOR_TRADES = [
  "Grey Structure",
  "Brick Masonry",
  "Plastering",
  "Flooring / Tiles",
  "Painting & Finishing",
  "Electrical Works",
  "Plumbing Works",
  "Steel Fixing / Barbending",
  "Shuttering / Formwork",
  "False Ceiling",
  "HVAC Works",
  "Woodwork / Carpentry",
  "Aluminum & Glass",
  "Waterproofing",
  "Demolition / Excavation",
  "General Labor",
];

function AddContractorsAndVendors({ isContractor = true }) {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const populatedata = location.state || {};
  const [isLoading, setIsLoading] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(
    populatedata.Image ? `data:image/*;base64,${populatedata.Image}` : null,
  );

  const [cnicFile, setCnicFile] = useState(null);
  const cnicInputRef = useRef(null);

  // Multi-select trade tags for contractor
  const [selectedTrades, setSelectedTrades] = useState(() => {
    if (populatedata.Trade || populatedata.Specialty) {
      const tr = populatedata.Trade || populatedata.Specialty;
      if (Array.isArray(tr)) {
        return tr;
      }
      return tr
        .split(",")
        .map((t) => t.trim())
        .filter(Boolean);
    }
    return [];
  });

  const tradeOptions = CONTRACTOR_TRADES.map((trade) => ({
    value: trade,
    label: trade,
  }));

  const [formData, setFormData] = useState({
    // Existing fields preserved
    Name: populatedata.Name || populatedata.VendorName || "",
    Email: populatedata.Email || populatedata.ContactEmail || "",
    PhoneNumber: populatedata.PhoneNumber || populatedata.ContactPhone || "",
    ContactNo1: populatedata.ContactNo1 || "",
    ContactNo2: populatedata.ContactNo2 || "",
    Address: populatedata.Address || "",
    Country: populatedata.Country || "Pakistan-PK",
    State: populatedata.State || "",
    City: populatedata.City || "",

    // Contractor specific fields
    CnicNumber:
      populatedata.CnicNumber || populatedata.CNIC || populatedata.Cnic || (isContractor ? "" : ""),
    ContractorType: populatedata.ContractorType || "Labour Only (Item Rate)",
    WhtRate: populatedata.WhtRate ?? populatedata.WHTRate ?? 3.0,
    OpeningAdvanceBalance: populatedata.OpeningAdvanceBalance ?? populatedata.OpeningBalance ?? 0,
    RetentionRate: populatedata.RetentionRate ?? populatedata.DefaultRetentionRate ?? 5.0,
    PreferredPaymentMode:
      populatedata.PreferredPaymentMode || populatedata.PaymentMode || "Bank Transfer (IBFT/RTGS)",

    // Common and Vendor fields
    ContactPersonName: populatedata.ContactPersonName || "",
    Designation: populatedata.Designation || "",
    Trade:
      populatedata.Trade ||
      populatedata.VendorCategory ||
      populatedata.SuppliedCategories ||
      "Cement & Admixtures",
    PaymentTerms: populatedata.PaymentTerms,
    NtnCnic:
      populatedata.NtnCnic || populatedata.NTN || populatedata.TaxId || (isContractor ? "" : ""),
    CreditLimit: populatedata.CreditLimit || "",
    TaxStatus: populatedata.TaxStatus || "Active Filer",
    Strn: populatedata.Strn || populatedata.STRN || "",
    BankName: populatedata.BankName || "",
    IbanAccount: populatedata.IbanAccount || populatedata.IBAN || "",
    AccountTitle: populatedata.AccountTitle || "",
    BranchCode: populatedata.BranchCode || populatedata.Branch || "",
  });

  // const [allCountries, setallCountries] = useState([]);
  const [allStates, setallStates] = useState([]);
  const [allCity, setallCity] = useState([]);

  // useEffect(() => {
  //   const data = Country?.getAllCountries()?.map((country) => ({
  //     value: country.name,
  //     displayValue: `${country.name}-${country.isoCode}`,
  //     isoCode: country.isoCode,
  //   }));
  //   setallCountries(data || []);
  // }, []);

  useEffect(() => {
    const countryCode = formData.Country?.includes("-")
      ? formData.Country?.split("-")[1]
      : formData.Country || "PK";
    if (countryCode) {
      const data = State.getStatesOfCountry(countryCode)?.map((state) => ({
        value: state.name,
        displayValue: `${state.name}-${state.isoCode}`,
        isoCode: state.isoCode,
      }));
      setallStates(data || []);
    } else {
      setallStates([]);
    }
  }, [formData.Country]);

  useEffect(() => {
    const countryCode = formData.Country?.includes("-")
      ? formData.Country?.split("-")[1]
      : formData.Country || "PK";
    const stateCode = formData.State?.includes("-")
      ? formData.State?.split("-")[1]
      : formData.State;
    if (countryCode && stateCode) {
      const data = City.getCitiesOfState(countryCode, stateCode).map((city) => ({
        value: city.name,
        displayValue: city.name,
      }));
      setallCity(data || []);
    } else {
      setallCity([]);
    }
  }, [formData.Country, formData.State]);

  useEffect(() => {
    if (location.state) {
      const p = location.state;
      setFormData({
        Name: p.Name || p.VendorName || "",
        Email: p.Email || p.ContactEmail || "",
        PhoneNumber: p.PhoneNumber || p.ContactPhone || "",
        ContactNo1: p.ContactNo1 || "",
        ContactNo2: p.ContactNo2 || "",
        Address: p.Address || "",
        Country: p.Country || "Pakistan-PK",
        State: p.State || "",
        City: p.City || "",
        CnicNumber: p.CnicNumber || p.CNIC || p.Cnic || "",
        ContractorType: p.ContractorType || "Labour Only (Item Rate)",
        WhtRate: p.WhtRate ?? p.WHTRate ?? 3.0,
        OpeningAdvanceBalance: p.OpeningAdvanceBalance ?? p.OpeningBalance ?? 0,
        RetentionRate: p.RetentionRate ?? p.DefaultRetentionRate ?? 5.0,
        PreferredPaymentMode:
          p.PreferredPaymentMode || p.PaymentMode || "Bank Transfer (IBFT/RTGS)",
        ContactPersonName: p.ContactPersonName || "",
        Designation: p.Designation || "",
        Trade: p.Trade || p.VendorCategory || p.SuppliedCategories || "Cement & Admixtures",
        PaymentTerms: p.PaymentTerms || "15 Days Credit",
        NtnCnic: p.NtnCnic || p.NTN || p.TaxId || "",
        CreditLimit: p.CreditLimit || "",
        TaxStatus: p.TaxStatus || "Active Filer",
        Strn: p.Strn || p.STRN || "",
        BankName: p.BankName || "",
        IbanAccount: p.IbanAccount || p.IBAN || "",
        AccountTitle: p.AccountTitle || "",
        BranchCode: p.BranchCode || p.Branch || "",
      });
      if (p.Image) {
        setImagePreview(`data:image/*;base64,${p.Image}`);
      }
      if (p.Trade || p.Specialty) {
        const tr = p.Trade || p.Specialty;
        if (Array.isArray(tr)) {
          setSelectedTrades(tr);
        } else {
          setSelectedTrades(
            tr
              .split(",")
              .map((t) => t.trim())
              .filter(Boolean),
          );
        }
      }
    }
  }, [location.state]);

  const handleChange = (e) => {
    const { id, name } = e.target;
    const fieldKey = name || id;
    let { value } = e.target;

    // Formatting logic for phone numbers
    if (fieldKey === "ContactNo1" || fieldKey === "ContactNo2") {
      value = value.replace(/[^0-9]/g, "");
      if (value.length > 4) {
        value = `${value.slice(0, 4)}-${value.slice(4)}`;
      }
      if (value.length > 12) {
        value = value.slice(0, 12);
      }
    } else if (fieldKey === "PhoneNumber") {
      value = value.replace(/[^0-9]/g, "");
      if (value.length > 4) {
        value = `${value.slice(0, 4)}-${value.slice(4)}`;
      }
      if (value.length > 12) {
        value = value.slice(0, 12);
      }
    } else if (fieldKey === "CnicNumber" || fieldKey === "CNIC") {
      value = value.replace(/[^0-9]/g, "");
      if (value.length > 5 && value.length <= 12) {
        value = `${value.slice(0, 5)}-${value.slice(5)}`;
      } else if (value.length > 12) {
        value = `${value.slice(0, 5)}-${value.slice(5, 12)}-${value.slice(12, 13)}`;
      }
    }

    setFormData((prev) => ({
      ...prev,
      [fieldKey]: value,
    }));
  };

  // Dropdown options
  // const tradeOptions = useMemo(() => {
  //   const base = [
  //     { value: "", label: "Select Trade / Category" },
  //     { value: "Cement & Admixtures", label: "Cement & Admixtures" },
  //     { value: "Steel & Rebar", label: "Steel & Rebar" },
  //     { value: "Bricks & Masonry", label: "Bricks & Masonry" },
  //     { value: "Sand & Aggregates", label: "Sand & Aggregates" },
  //     { value: "Plumbing & Sanitary", label: "Plumbing & Sanitary" },
  //     { value: "Electrical & Lighting", label: "Electrical & Lighting" },
  //     { value: "Paints & Chemicals", label: "Paints & Chemicals" },
  //     { value: "Wood & Timber", label: "Wood & Timber" },
  //     { value: "Tiles & Flooring", label: "Tiles & Flooring" },
  //     { value: "Hardware & Tools", label: "Hardware & Tools" },
  //     { value: "Safety & PPE", label: "Safety & PPE" },
  //     { value: "Subcontractor / Labor", label: "Subcontractor / Labor" },
  //     { value: "General Consumables", label: "General Consumables" },
  //     { value: "Other", label: "Other" },
  //   ];
  //   if (formData.Trade && !base.some((t) => t.value === formData.Trade)) {
  //     base.splice(1, 0, { value: formData.Trade, label: formData.Trade });
  //   }
  //   return base;
  // }, [formData.Trade]);

  const paymentTermsOptions = useMemo(() => {
    const base = [
      { value: "15 Days Credit", label: "15 Days Credit" },
      { value: "30 Days Credit", label: "30 Days Credit" },
      { value: "45 Days Credit", label: "45 Days Credit" },
      { value: "60 Days Credit", label: "60 Days Credit" },
      { value: "Cash on Delivery", label: "Cash on Delivery (COD)" },
      { value: "Advance Payment", label: "Advance Payment" },
      { value: "Immediate / Due on Receipt", label: "Immediate / Due on Receipt" },
    ];
    if (formData.PaymentTerms && !base.some((p) => p.value === formData.PaymentTerms)) {
      base.splice(0, 0, { value: formData.PaymentTerms, label: formData.PaymentTerms });
    }
    return base;
  }, [formData.PaymentTerms]);

  const stateOptions = useMemo(() => {
    const base = [
      { value: "", label: "Select State / Province" },
      ...allStates.map((s) => ({ value: s.value, label: s.value })),
    ];
    if (formData.State && !base.some((s) => s.value === formData.State)) {
      base.splice(1, 0, { value: formData.State, label: formData.State });
    }
    return base;
  }, [allStates, formData.State]);

  const cityOptions = useMemo(() => {
    const base = [
      { value: "", label: "Select City" },
      ...allCity.map((c) => ({ value: c.value, label: c.value })),
    ];
    if (formData.City && !base.some((c) => c.value === formData.City)) {
      base.splice(1, 0, { value: formData.City, label: formData.City });
    }
    return base;
  }, [allCity, formData.City]);

  // Handle form submission
  async function addContractor(e) {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    const {
      Name,
      Email,
      PhoneNumber,
      ContactNo1,
      ContactNo2,
      Address,
      City: selectedCity,
      State: selectedState,
      Country: selectedCountry,
      ContactPersonName,
      Designation,
      Trade,
      PaymentTerms,
      NtnCnic,
      CreditLimit,
      TaxStatus,
      Strn,
      BankName,
      IbanAccount,
      AccountTitle,
      BranchCode,
      CnicNumber,
      ContractorType,
      WhtRate,
      OpeningAdvanceBalance,
      RetentionRate,
      PreferredPaymentMode,
    } = formData;

    if (!Name) {
      toast.info(
        isContractor
          ? "Contractor / Company Name is required"
          : "Business / Company Name is required",
      );
      return;
    }

    if (isContractor && !CnicNumber) {
      toast.info("CNIC Number is required for contractor");
      return;
    }

    if (PhoneNumber && !PhoneNumber.match(/^[0-9+\-\s()]+$/)) {
      toast.info("Please enter a valid phone number");
      return;
    }

    const data = new FormData();
    data.append(isContractor ? "ContractorId" : "VendorId", populatedata.Id || 0);

    // Common fields preserved
    data.append("Name", Name);
    data.append("Address", Address);
    data.append("PhoneNumber", PhoneNumber);
    data.append("ContactNo1", ContactNo1);
    data.append("ContactNo2", ContactNo2);
    data.append("City", selectedCity);
    data.append("Country", selectedCountry || "Pakistan");
    data.append("State", selectedState);
    data.append("Email", Email);
    data.append("ContactPersonName", ContactPersonName);
    data.append("Designation", Designation);
    data.append("TaxStatus", TaxStatus);
    data.append("BankName", BankName);
    data.append("IbanAccount", IbanAccount);
    data.append("IBAN", IbanAccount);
    data.append("AccountTitle", AccountTitle);
    data.append("BranchCode", BranchCode);

    if (isContractor) {
      // Contractor-specific fields
      data.append("CnicNumber", CnicNumber);
      data.append("CNIC", CnicNumber);
      data.append("ContractorType", ContractorType);
      data.append("Trade", selectedTrades.join(", "));
      data.append("Specialty", selectedTrades.join(", "));
      data.append("WhtRate", String(WhtRate || 0));
      data.append("OpeningAdvanceBalance", String(OpeningAdvanceBalance || 0));
      data.append("RetentionRate", String(RetentionRate || 0));
      data.append("DefaultRetentionRate", String(RetentionRate || 0));
      data.append("PreferredPaymentMode", PreferredPaymentMode);
      data.append("PaymentMode", PreferredPaymentMode);
      data.append("NtnCnic", NtnCnic || CnicNumber);
      data.append("NTN", NtnCnic);
      data.append("TaxId", NtnCnic || CnicNumber);

      if (cnicFile) {
        data.append("CnicDocument", cnicFile);
      }
    } else {
      // Vendor-specific fields
      data.append("Trade", Trade);
      data.append("SuppliedCategories", Trade);
      data.append("VendorCategory", Trade);
      data.append("PaymentTerms", PaymentTerms);
      data.append("NtnCnic", NtnCnic);
      data.append("NTN", NtnCnic);
      data.append("TaxId", NtnCnic);
      data.append("CreditLimit", CreditLimit);
      data.append("Strn", Strn);
      data.append("STRN", Strn);
    }

    if (imageFile) {
      data.append("Image", imageFile);
    } else if (populatedata.Image) {
      data.append("Image", populatedata.Image);
    }

    setIsLoading(true);
    try {
      let result;
      if (populatedata.Id) {
        result = isContractor
          ? await UpdateContractorApi(data, populatedata.Id)
          : await UpdateVendorApi(data, populatedata.Id);
      } else {
        result = isContractor ? await AddContractorApi(data) : await AddVendorApi(data);
      }

      if (result?.data?.IsSuccess) {
        toast.success(
          result.data.Message ||
            (isContractor ? "Contractor saved successfully" : "Vendor saved successfully"),
        );
        if (isContractor) {
          dispatch(getallContractors());
        } else {
          dispatch(getallVendors());
        }
        history.goBack();
      } else {
        toast.error(
          isContractor
            ? result?.data?.Message || "Failed to save contractor"
            : result?.data?.Message || "Failed to save vendor",
        );
      }
    } catch (error) {
      toast.error(isContractor ? "Error saving contractor" : "Error saving vendor");
    } finally {
      setIsLoading(false);
    }
  }

  function handleImageChange(e) {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  }

  function handleAvatarClick() {
    const input = document.getElementById("ImageInput");
    if (input) {
      input.click();
    }
  }

  return (
    <div className="vendor-screen-wrapper">
      {/* Page Header */}
      <div className="col-md-12 text-left page_heading">
        <div className="d-flex align-items-center">
          <FaArrowLeft
            size={16}
            style={{ cursor: "pointer", marginRight: "12px" }}
            title="Back"
            onClick={() => history.goBack()}
          />
          <h2 className="grn-header-title">
            {populatedata.Id ? "Edit" : "Add"} {isContractor ? "Contractor" : "Vendor"}
          </h2>
        </div>
      </div>

      <form onSubmit={addContractor} autoComplete="off">
        {/* ===================== CONTRACTOR LAYOUT ===================== */}
        {isContractor ? (
          <>
            {/* CARD 1: Contractor & Identity Details */}
            <div className="vendor-card">
              <h5 className="vendor-card-title">Contractor & Identity Details</h5>

              {/* Row 1 */}
              <div className="row mb-2">
                <InputField
                  label="Contractor / Company Name:"
                  name="Name"
                  value={formData.Name}
                  onChange={handleChange}
                  placeholder="e.g. Haji Aslam & Sons Construction"
                  required
                  stacked
                  wrapperCol="col-xl-3 col-lg-4 col-md-6 col-12"
                />
                <InputField
                  label="CNIC Number:"
                  name="CnicNumber"
                  value={formData.CnicNumber}
                  onChange={handleChange}
                  placeholder="33100-1234567-1"
                  required
                  stacked
                  wrapperCol="col-xl-3 col-lg-4 col-md-6 col-12"
                />
                <InputField
                  label="Contact Person Name:"
                  name="ContactPersonName"
                  value={formData.ContactPersonName}
                  onChange={handleChange}
                  placeholder="e.g. Haji Muhammad Aslam"
                  stacked
                  wrapperCol="col-xl-3 col-lg-4 col-md-6 col-12"
                />
                <InputField
                  label="Mobile / WhatsApp:"
                  name="PhoneNumber"
                  value={formData.PhoneNumber}
                  onChange={handleChange}
                  placeholder="0300-7654321"
                  required
                  stacked
                  wrapperCol="col-xl-3 col-lg-4 col-md-6 col-12"
                />
                <InputField
                  label="Alternative Phone:"
                  name="ContactNo1"
                  value={formData.ContactNo1}
                  onChange={handleChange}
                  placeholder="0321-7654321"
                  stacked
                  wrapperCol="col-xl-3 col-lg-4 col-md-6 col-12"
                />
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 stacked-form-field mb-3">
                  <label className="input_label d-block m-0 mb-2">
                    Trade / Specialty:
                    <span className="estaric text-danger ml-1">*</span>
                  </label>
                  <Select
                    isMulti
                    options={tradeOptions}
                    value={selectedTrades.map((trade) => ({ value: trade, label: trade }))}
                    onChange={(selected) =>
                      setSelectedTrades((selected || []).map((item) => item.value))
                    }
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    placeholder="Select trade / specialty..."
                    className="contractor-trade-select"
                    classNamePrefix="contractor-trade"
                  />
                </div>
                <div className="col-lg-6 col-md-6 col-12 stacked-form-field mb-3">
                  <label className="input_label d-block m-0 mb-2">
                    Contractor Type:
                    <span className="estaric text-danger ml-1">*</span>
                  </label>
                  <div className="vendor-tax-pill-group contractor-type-pills">
                    <button
                      type="button"
                      className={`vendor-tax-pill contractor-type-pill ${formData.ContractorType === "Labour Only (Item Rate)" ? "active" : ""}`}
                      onClick={() =>
                        setFormData((prev) => ({
                          ...prev,
                          ContractorType: "Labour Only (Item Rate)",
                        }))
                      }
                    >
                      Labour Only (Item Rate)
                    </button>
                    <button
                      type="button"
                      className={`vendor-tax-pill contractor-type-pill ${formData.ContractorType === "With Material (Turnkey)" ? "active" : ""}`}
                      onClick={() =>
                        setFormData((prev) => ({
                          ...prev,
                          ContractorType: "With Material (Turnkey)",
                        }))
                      }
                    >
                      With Material (Turnkey)
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* CARD 2: Tax & Commercial Terms */}
            <div className="vendor-card">
              <div className="vendor-card-header">
                <h5 className="vendor-card-title">Tax & Commercial Terms</h5>

                <div className="vendor-tax-pill-group">
                  <button
                    type="button"
                    className={`vendor-tax-pill ${
                      formData.TaxStatus === "Active Filer" ? "active" : ""
                    }`}
                    onClick={() => setFormData((prev) => ({ ...prev, TaxStatus: "Active Filer" }))}
                  >
                    Filer
                  </button>

                  <button
                    type="button"
                    className={`vendor-tax-pill ${
                      formData.TaxStatus === "Non-Filer" ? "active" : ""
                    }`}
                    onClick={() => setFormData((prev) => ({ ...prev, TaxStatus: "Non-Filer" }))}
                  >
                    Non-Filer
                  </button>
                </div>
              </div>

              <div className="row mb-2">
                {formData.TaxStatus !== "Non-Filer" && (
                  <InputField
                    label="NTN:"
                    name="NtnCnic"
                    value={formData.NtnCnic}
                    onChange={handleChange}
                    placeholder="7894561-2"
                    stacked
                    wrapperCol="col-xl-3 col-lg-4 col-md-6 col-12"
                  />
                )}

                <InputField
                  label="WHT Rate (%):"
                  name="WhtRate"
                  type="number"
                  step="0.1"
                  value={formData.WhtRate}
                  onChange={handleChange}
                  placeholder="3.0"
                  stacked
                  wrapperCol="col-xl-3 col-lg-4 col-md-6 col-12"
                />

                <InputField
                  label="Opening Advance Balance:"
                  name="OpeningAdvanceBalance"
                  type="number"
                  value={formData.OpeningAdvanceBalance}
                  onChange={handleChange}
                  placeholder="0"
                  stacked
                  wrapperCol="col-xl-3 col-lg-4 col-md-6 col-12"
                />

                <InputField
                  label="Default Retention Rate (%):"
                  name="RetentionRate"
                  type="number"
                  step="0.1"
                  value={formData.RetentionRate}
                  onChange={handleChange}
                  placeholder="5.0"
                  stacked
                  wrapperCol="col-xl-3 col-lg-4 col-md-6 col-12"
                />
              </div>
            </div>

            {/* ROW 3: Payment Preference & Address / CNIC Attachments */}
            <div className="row">
              {/* CARD 3 (Left): Payment / Disbursement Preference */}
              <div className="col-lg-6 col-md-12">
                <div className="vendor-card h-100">
                  <h5 className="vendor-card-title">Payment / Disbursement Preference</h5>

                  <div className="row mb-2 align-items-center">
                    <SelectField
                      label="Preferred Payment Mode:"
                      name="PreferredPaymentMode"
                      value={formData.PreferredPaymentMode}
                      onChange={handleChange}
                      options={[
                        {
                          value: "Bank Transfer (IBFT/RTGS)",
                          label: "Bank Transfer (IBFT/RTGS)",
                        },
                        { value: "Cash at Site", label: "Cash at Site" },
                      ]}
                      stacked
                      wrapperCol="col-lg-6 col-md-6 col-12"
                    />

                    {formData.PreferredPaymentMode !== "Cash at Site" && (
                      <>
                        <InputField
                          label="Bank Name:"
                          name="BankName"
                          value={formData.BankName}
                          onChange={handleChange}
                          placeholder="e.g. Meezan Bank Ltd"
                          stacked
                          wrapperCol="col-xl-6 col-lg-6 col-md-6 col-12"
                        />
                        <InputField
                          label="Account Title:"
                          name="AccountTitle"
                          value={formData.AccountTitle}
                          onChange={handleChange}
                          placeholder="e.g. Muhammad Aslam"
                          stacked
                          wrapperCol="col-xl-6 col-lg-6 col-md-6 col-12"
                        />
                        <InputField
                          label="IBAN / Account Number:"
                          name="IbanAccount"
                          value={formData.IbanAccount}
                          onChange={handleChange}
                          placeholder="PK12MEZN000123..."
                          stacked
                          wrapperCol="col-xl-6 col-lg-6 col-md-6 col-12"
                        />
                      </>
                    )}
                  </div>
                </div>
              </div>

              {/* CARD 4 (Right): Address & CNIC Attachments */}
              <div className="col-lg-6 col-md-12 ">
                <div className="vendor-card h-100">
                  <h5 className="vendor-card-title">Address & CNIC Attachments</h5>

                  <div className="row align-items-center">
                    <SelectField
                      label="City:"
                      name="City"
                      value={formData.City}
                      onChange={handleChange}
                      options={cityOptions}
                      labelCol="col-md-4"
                      inputCol="col-md-8"
                      stacked
                      wrapperCol="col-lg-6 col-md-6 col-12"
                    />
                    <SelectField
                      label="State:"
                      name="State"
                      value={formData.State}
                      onChange={handleChange}
                      options={stateOptions}
                      labelCol="col-md-4"
                      inputCol="col-md-8"
                      stacked
                      wrapperCol="col-lg-6 col-md-6 col-12"
                    />
                  </div>

                  <div className="row align-items-start">
                    <TextAreaField
                      label="Address:"
                      name="Address"
                      value={formData.Address}
                      onChange={handleChange}
                      placeholder="e.g. Chak 214 RB, Near Shell Pump, Faisalabad"
                      rows={2}
                      stacked
                      wrapperCol="col-lg-6 col-md-6 col-12"
                    />

                    {/* CNIC Document Attachment */}
                    <div className="col-lg-6 col-md-6 col-12 stacked-form-field mb-3">
                      <label className="input_label d-block m-0 mb-2">CNIC Scan & Documents:</label>
                      <div
                        className="document-upload-box"
                        role="button"
                        tabIndex={0}
                        onClick={() => cnicInputRef.current && cnicInputRef.current.click()}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            cnicInputRef.current && cnicInputRef.current.click();
                          }
                        }}
                      >
                        <BsCloudUpload className="document-upload-icon" />
                        {cnicFile ? (
                          <div className="document-upload-file">
                            <span>{cnicFile.name}</span>
                            <button
                              type="button"
                              className="document-upload-remove"
                              onClick={(e) => {
                                e.stopPropagation();
                                setCnicFile(null);
                                if (cnicInputRef.current) {
                                  cnicInputRef.current.value = "";
                                }
                              }}
                              title="Remove document"
                            >
                              ×
                            </button>
                          </div>
                        ) : (
                          <div className="document-upload-copy">
                            <strong>Click to upload</strong>
                            <span>CNIC, image or PDF</span>
                          </div>
                        )}
                        <input
                          type="file"
                          ref={cnicInputRef}
                          className="d-none"
                          accept="image/*,application/pdf"
                          onChange={(e) => {
                            const f = e.target.files[0];
                            if (f) {
                              setCnicFile(f);
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          /* ===================== VENDOR LAYOUT ===================== */
          <>
            {/* CARD 1: Business & Contact Information */}
            <div className="vendor-card">
              <h5 className="vendor-card-title">Business & Contact Information</h5>

              {/* Row 1 */}
              <div className="row mb-2">
                <InputField
                  label="Company Name:"
                  name="Name"
                  value={formData.Name}
                  onChange={handleChange}
                  placeholder="e.g. Bestway Cement Ltd"
                  required
                  stacked
                  wrapperCol="col-xl-3 col-lg-4 col-md-6 col-12"
                />
                <InputField
                  label="Mobile / WhatsApp:"
                  name="PhoneNumber"
                  value={formData.PhoneNumber}
                  onChange={handleChange}
                  placeholder="0300-1234567"
                  required
                  stacked
                  wrapperCol="col-xl-3 col-lg-4 col-md-6 col-12"
                />

                <InputField
                  label="Email:"
                  name="Email"
                  type="email"
                  value={formData.Email}
                  onChange={handleChange}
                  placeholder="sales@bestway.com.pk"
                  stacked
                  wrapperCol="col-xl-3 col-lg-4 col-md-6 col-12"
                />
                <InputField
                  label="Contact Person Name:"
                  name="ContactPersonName"
                  value={formData.ContactPersonName}
                  onChange={handleChange}
                  placeholder="Sheikh Rizwan (Sales Manager)"
                  stacked
                  wrapperCol="col-xl-3 col-lg-4 col-md-6 col-12"
                />
                <InputField
                  label="Office Phone:"
                  name="ContactNo1"
                  value={formData.ContactNo1}
                  onChange={handleChange}
                  placeholder="041-8765432"
                  stacked
                  wrapperCol="col-xl-3 col-lg-4 col-md-6 col-12"
                />
                <SelectField
                  label="Supplied Categories:"
                  name="Trade"
                  value={formData.Trade}
                  onChange={handleChange}
                  options={tradeOptions}
                  required
                  stacked
                  wrapperCol="col-xl-3 col-lg-4 col-md-6 col-12"
                />
                <InputField
                  label="Designation:"
                  name="Designation"
                  value={formData.Designation}
                  onChange={handleChange}
                  placeholder="Regional Head"
                  stacked
                  wrapperCol="col-xl-3 col-lg-4 col-md-6 col-12"
                />

                {/* Logo / Avatar Upload */}
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 stacked-form-field mb-3">
                  <label className="input_label d-block m-0 mb-2">Vendor Logo / Photo:</label>
                  <div className="vendor-logo-upload">
                    <button
                      type="button"
                      className="vendor-logo-preview"
                      onClick={handleAvatarClick}
                      title="Click to upload logo/image"
                    >
                      <img src={imagePreview || noImage} alt="Vendor logo preview" />
                    </button>
                    <button
                      type="button"
                      className="vendor-logo-action"
                      onClick={handleAvatarClick}
                    >
                      Upload
                    </button>
                    {imagePreview && (
                      <button
                        type="button"
                        className="vendor-logo-remove"
                        onClick={() => {
                          setImagePreview(null);
                          setImageFile(null);
                          const el = document.getElementById("ImageInput");
                          if (el) {
                            el.value = "";
                          }
                        }}
                        title="Remove image"
                      >
                        ×
                      </button>
                    )}
                  </div>
                  <input
                    type="file"
                    id="ImageInput"
                    className="d-none"
                    accept="image/*"
                    onChange={handleImageChange}
                  />
                </div>
              </div>
            </div>

            {/* CARD 2: Tax & Commercial Terms */}
            <div className="vendor-card">
              <div className="vendor-card-header">
                <h5 className="vendor-card-title">Tax & Commercial Terms</h5>

                <div className="vendor-tax-pill-group">
                  <button
                    type="button"
                    className={`vendor-tax-pill ${
                      formData.TaxStatus === "Active Filer" ? "active" : ""
                    }`}
                    onClick={() => setFormData((prev) => ({ ...prev, TaxStatus: "Active Filer" }))}
                  >
                    Filer
                  </button>

                  <button
                    type="button"
                    className={`vendor-tax-pill ${
                      formData.TaxStatus === "Non-Filer" ? "active" : ""
                    }`}
                    onClick={() => setFormData((prev) => ({ ...prev, TaxStatus: "Non-Filer" }))}
                  >
                    Non-Filer
                  </button>
                </div>
              </div>

              {/* Row 1 */}
              <div className="row mb-2">
                <SelectField
                  label="Default Payment Terms:"
                  name="PaymentTerms"
                  value={formData.PaymentTerms}
                  onChange={handleChange}
                  options={paymentTermsOptions}
                  stacked
                  wrapperCol="col-xl-3 col-lg-4 col-md-6 col-12"
                />
                {formData.TaxStatus === "Active Filer" && (
                  <InputField
                    label="NTN:"
                    name="NtnCnic"
                    value={formData.NtnCnic}
                    onChange={handleChange}
                    placeholder="1234567-8"
                    stacked
                    wrapperCol="col-xl-3 col-lg-4 col-md-6 col-12"
                  />
                )}
                <InputField
                  label="Credit Limit (PKR):"
                  name="CreditLimit"
                  value={formData.CreditLimit}
                  onChange={handleChange}
                  placeholder="5,000,000"
                  stacked
                  wrapperCol="col-xl-3 col-lg-4 col-md-6 col-12"
                />
                <InputField
                  label="STRN (Sales Tax No.):"
                  name="Strn"
                  value={formData.Strn}
                  onChange={handleChange}
                  placeholder="04-01-1234-567-89"
                  stacked
                  wrapperCol="col-xl-3 col-lg-4 col-md-6 col-12"
                />
              </div>

              {/* Row 3 */}
            </div>

            {/* ROW 3: Banking Details & Address & Location */}
            <div className="row">
              {/* CARD 3 (Left): Banking Details (For Payouts) */}
              <div className="col-lg-6 col-md-12">
                <div className="vendor-card h-100">
                  <h5 className="vendor-card-title">Banking Details (For Payouts)</h5>

                  <div className="row mb-2 align-items-center">
                    <InputField
                      label="Bank Name:"
                      name="BankName"
                      value={formData.BankName}
                      onChange={handleChange}
                      placeholder="e.g. Meezan Bank Ltd"
                      stacked
                      wrapperCol="col-lg-6 col-md-6 col-12"
                    />
                    <InputField
                      label="IBAN / Account Number:"
                      name="IbanAccount"
                      value={formData.IbanAccount}
                      onChange={handleChange}
                      placeholder="PK45MEZN0001234567-R&5ME..."
                      stacked
                      wrapperCol="col-lg-6 col-md-6 col-12"
                    />
                    <InputField
                      label="Account Title:"
                      name="AccountTitle"
                      value={formData.AccountTitle}
                      onChange={handleChange}
                      placeholder="Bestway Cement Sales Account"
                      stacked
                      wrapperCol="col-lg-6 col-md-6 col-12"
                    />
                    <InputField
                      label="Branch / Code:"
                      name="BranchCode"
                      value={formData.BranchCode}
                      onChange={handleChange}
                      placeholder="Peoples Colony, FSD"
                      stacked
                      wrapperCol="col-lg-6 col-md-6 col-12"
                    />
                  </div>
                </div>
              </div>

              {/* CARD 4 (Right): Address & Location */}
              <div className="col-lg-6 col-md-12 ">
                <div className="vendor-card h-100">
                  <h5 className="vendor-card-title">Address & Location</h5>

                  <div className="row mb-2 align-items-center">
                    <SelectField
                      label="City:"
                      name="City"
                      value={formData.City}
                      onChange={handleChange}
                      options={cityOptions}
                      stacked
                      wrapperCol="col-lg-6 col-md-6 col-12"
                    />
                    <SelectField
                      label="State:"
                      name="State"
                      value={formData.State}
                      onChange={handleChange}
                      options={stateOptions}
                      stacked
                      wrapperCol="col-lg-6 col-md-6 col-12"
                    />
                    <TextAreaField
                      label="Street Address:"
                      name="Address"
                      value={formData.Address}
                      onChange={handleChange}
                      placeholder="Plot 45, Small Industrial Estate, Sargodha Road"
                      rows={3}
                      stacked
                      wrapperCol=" col-12"
                    />
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        {/* Bottom Action Buttons */}
        <div className="col-12 p-0">
          <div className="float-right mt-2 mb-4">
            <ActionButton
              text="Cancel"
              variant="cancel"
              type="button"
              onClick={() => history.goBack()}
              disabled={isLoading}
            />
            <ActionButton
              text={`Save ${isContractor ? "Contractor" : "Vendor"}`}
              icon={BsCloudUpload}
              type="submit"
              onClick={addContractor}
              disabled={isLoading}
              isLoading={isLoading}
            />
          </div>
        </div>
      </form>
    </div>
  );
}

export default AddContractorsAndVendors;
